<template>
  <div class="home">
    <Header :showNav="showNav" v-on:open-nav="showNav = true" />
    <SideNav :showNav="showNav" v-on:close-nav="showNav = false" v-on:close-nav-scroll="closeNavScroll($event)" />

    <Hero />

    <Services :services="services"/>

    <About :aboutText="about" v-on:scroll="scrollTo($event)"/>

    <Brands :socialLinks="socialLinks" :shops="shops" :brands="brands" :contactDetails="contactDetails"/>

    <Partners :partners="partners" />

    <Contact :contactDetails="contactDetails" :contactFormEmails="contactFormEmails"/>

    <Footer :socialLinks="socialLinks" :shops="shops" :brands="brands" :contactDetails="contactDetails"/>
  </div>
</template>

<script>
import {db} from '@/firebase.js'

import Header from '@/components/home/Header.vue'
import SideNav from '@/components/home/SideNav.vue'
import Hero from '@/components/home/Hero.vue'
import Services from '@/components/home/Services.vue'
import About from '@/components/home/About.vue'
import Brands from '@/components/home/Brands.vue'
import Partners from '@/components/home/Partners.vue'
import Contact from '@/components/home/Contact.vue'
import Footer from '@/components/home/Footer.vue'

export default {
  name: 'home',
  components: {
    Header,
    SideNav,
    Hero,
    Services,
    About,
    Brands,
    Partners,
    Contact,
    Footer
  },
  data() {
    return {
      showNav: false,
      about: null,
      services: [],
      brands: [],
      partners: [],
      contactFormEmails: [],
      contactDetails: {},
      shops: [],
      socialLinks: {}
    }
  },
  methods: {
    closeNavScroll(payload) {
      this.showNav = false
      this.scrollTo(payload)
    },
    scrollTo(elem) {
      var bodyRect = document.body.getBoundingClientRect(),
          elemRect = document.querySelector(elem).getBoundingClientRect(),
          offset   = elemRect.top - bodyRect.top - 40;

      window.scroll({
        top: offset, 
        left: 0,
        behavior: 'smooth'
      });
    }
  },
  watch: {
    showNav() {
      if (this.showNav) {
        document.body.classList.add('no-scroll')
      } else {
        document.body.classList.remove('no-scroll')
      }
    }
  },
  created() {
    db.collection('app').doc('appData').get()
    .then(doc => {
      const data = doc.data()

      this.about = data.about
      this.services = data.services
      this.brands = data.brands
      this.partners = data.partners
      this.contactDetails = data.contactDetails
      this.contactFormEmails = data.contactFormEmails
      this.shops = data.shops
      this.socialLinks = data.socialLinks
    })
  }
}
</script>